module.exports = __webpack_public_path__ + "static/media/closing-img.9662c9f9.svg";